import type { Client } from '../types'

export const clients: Client[] = [
  { id: 'c1', name: 'Shajahan Jewelry', category: 'Jewelry' },
  { id: 'c2', name: 'Golden Computers', category: 'IT & Electronics' },
  { id: 'c3', name: 'Rapid Refills', category: 'Stationery & Supplies' },
  { id: 'c4', name: 'GK Traders', category: 'Wholesale Trading' },
  { id: 'c5', name: 'Pantip', category: 'Retail & Marketplace' },
  { id: 'c6', name: 'MN Communications', category: 'Telecommunications' },
  { id: 'c7', name: 'Malta Systems', category: 'Software & IT' },
  { id: 'c8', name: 'Carmel School', category: 'Education' },
  { id: 'c9', name: 'Joseph Hospital', category: 'Healthcare' },
  { id: 'c10', name: 'Nakshathra Palace', category: 'Events & Hospitality' },
]
